module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-1.51bec2f3.mp3";